module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('article', {
    attrs: {
      "epub:type": "frontmatter"
    }
  }, [_c('div', {
    staticClass: "bodymatter",
    attrs: {
      "epub:type": "bodymatter"
    }
  }, [_c('section', {
    attrs: {
      "epub:type": "division",
      "id": "toc"
    }
  }, [_c('h1', {
    staticClass: "toc_title"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc_partb"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_itr"
    }
  }, [_c('span', {
    staticClass: "tsplb"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_parta"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_p01"
    }
  }, [_c('span', {
    staticClass: "tblack"
  }, [_vm._v("PART I")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_partb"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_p01#p01"
    }
  }, [_c('span', {
    staticClass: "tsplb"
  }, [_vm._v("Let’s Begin")])])]), _vm._v(" "), _c('div', {
    staticClass: "tnum"
  }, [_c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("1  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("BACK TO THE BASICS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("2  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("CALLIGRAPHY VOCABULARY")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("3  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("PENS AND PEN POSITIONS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_parta"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_p02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tblack"
  }, [_vm._v("PART II")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_partb"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_p02#p02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsplb"
  }, [_vm._v("The Alphabets")])])]), _vm._v(" "), _c('div', {
    staticClass: "tnum"
  }, [_c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("4  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("ITALIC")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_par"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c04#c04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tblack"
  }, [_vm._v("A Quick Review")])])]), _vm._v(" "), _c('div', {
    staticClass: "tnum"
  }, [_c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("5  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("MORE ITALIC")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_par"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c05#c05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tblack"
  }, [_vm._v("Some New Letters")])])]), _vm._v(" "), _c('div', {
    staticClass: "tnum"
  }, [_c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("6  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("A BRIEF PAUSE FOR A MATH LESSON")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("7  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("BACK TO ITALIC")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_par"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c07#c07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tblack"
  }, [_vm._v("Changing the Weight of the Letters")])])]), _vm._v(" "), _c('div', {
    staticClass: "tnum"
  }, [_c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("8  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("SIMPLE ITALIC CAPITALS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("9  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("ITALIC HANDWRITING")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("10  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("SWING GOTHIC")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("11  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("MODERN GOTHIC")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_par"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c11#c11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tblack"
  }, [_vm._v("An Alphabet with Many Names")])])]), _vm._v(" "), _c('div', {
    staticClass: "tnum"
  }, [_c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("12  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("MODERN GOTHIC CAPITALS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("13  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("WRITING IN CAPITALS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_parta"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_p03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tblack"
  }, [_vm._v("PART III")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_partb"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_p03#p03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tsplb"
  }, [_vm._v("Creative Projects")])])]), _vm._v(" "), _c('div', {
    staticClass: "tnum"
  }, [_c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("14  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("WRITING LARGER")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("15  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("QUOTATION OR POEM")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("16  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("STATIONERY")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("17  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("ENVELOPES")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("18  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("MAKING SIGNS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("19  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("CALLIGRAMS")])])]), _vm._v(" "), _c('p', {
    staticClass: "tnum"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_c20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "stnum"
  }, [_vm._v("20  "), _c('img', {
    staticClass: "inline",
    attrs: {
      "alt": "",
      "src": "OEBPS/images/squ.jpg"
    }
  })]), _c('span', {
    staticClass: "tblack"
  }, [_vm._v("USING “REAL” PENS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fmbm"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781454936534_bm1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tblack"
  }, [_vm._v("Guide Lines")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0e8268c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781454936534_toc.vue
// module id = 72
// module chunks = 0